import img1 from './images/book1.jpg'
import img2 from './images/book2.jpg'
import img3 from './images/book3.jpg'
import img4 from './images/book4.jpg'
import img5 from './images/book5.jpg'
import img6 from './images/book6.jpg'

export const books = [
  {
    id: 1,
    title: 'Dog Man: Twenty Thousand',
    author: 'Dav Pilkey',
    // image: '../src/images/book1.jpg',
    image: img1,
  },
  {
    id: 2,
    title: 'Atomic Habits',
    author: 'James Clear',
    image: img2,
  },
  {
    id: 3,
    author: 'Colleen Hoover',
    title: 'It Starts with Us',
    image: img3,
  },
  {
    id: 4,
    author: 'Lucy Score',
    title: 'Things We Never Got Over',
    image: img4,
  },
  {
    id: 5,
    author: 'Colleen Hoover',
    title: 'It Ends with Us',
    image: img5,
  },
  {
    id: 6,
    author: 'Peter Attia MD',
    title: 'Outlive: The Science and Art of Longevity',
    image: img6,
  },
]
